<template>
    <div class="window white">
        <fieldset>
            <legend>Total {{ config.name }} pool deposits and daily volume</legend>
            <div :class="{'loading line': !total}" id='total-balances'>
                Deposits: <span v-show='total'>${{total | formatNumber}}</span>
            </div>
            <div v-if="!config.totalVolumeApiEndpoint" :class="{'loading line': sumVolumes < 0}" >
                Daily volume: <span v-show='sumVolumes >= 0'>${{sumVolumes | formatNumber(0)}}</span>
            </div>
            <div v-if="config.totalVolumeApiEndpoint" :class="{'loading line': typeof totalVolumeFromApi === 'undefined'}" >
                Daily volume: <span v-if='totalVolumeFromApi >= 0'>${{(Number(totalVolumeFromApi)) | formatNumber(0)}}</span>
            </div>
            <div v-if="config.totalVolumeApiEndpoint" :class="{'loading line': typeof totalVolumeFromApi === 'undefined'}" >
                Crypto Volume Share: <span v-if='totalVolumeFromApi >= 0'>{{(Number(cryptoShare)) | formatNumber(2)}}%</span>
            </div>
            <div v-show='sumBalances > 0'>
                My deposits: ${{ sumBalances.toFixed(2) | formatNumber(0) }}
            </div>
          </fieldset>
    </div>
</template>

<script>
import config from '@/constants/config'
import pools from '@/constants/pools'
import * as volumeStore from '@/components/common/volumeStore'
import getBalances from '@/utils/data/getBalances';
import * as priceStore from '../common/priceStore'
import getFactoryV2Pools from '@/utils/data/getFactoryV2Pools'
import getFactoryCryptoPools from '@/utils/data/getFactoryCryptoPools'
import { sum } from '@/utils/Array'
import Request from '@/utils/Request'
import getFactoryOnlyPoolsBalances from '@/utils/data/getFactoryOnlyPoolsBalances'
import {
    contract
} from '@/contract'

import * as balancesStore from './balancesStore'

export default {
    data: () => ({
        total: '',
        config,
        sumBalances: 0,
        totalVolume: undefined,
        factoryVolume: undefined,
        factoryV2Volume: undefined,
        factoryCryptoVolume: undefined,
        totalVolumeFromApi: undefined,
        cryptoShare: undefined
    }),
    computed: {
        volume() {
            return this.totalVolume !== undefined ? this.totalVolume : volumeStore.totalVolume()
        },

        sumVolumes() {
            return (Number(config.hasNoMainPools ? 0 : this.volume) + ((!!config.factoryV2RegistryAddress && this.factoryV2Volume >= 0) ? this.factoryV2Volume : 0) + ((!!config.factoryCryptoRegistryAddress && this.factoryCryptoVolume >= 0) ? this.factoryCryptoVolume : 0));
        },
    },
    async created() {
        // Fetch volume data
        if (config.totalVolumeApiEndpoint) {
            const { data: { totalVolume, cryptoShare } } = await (await Request.get(config.totalVolumeApiEndpoint)).json();
            this.totalVolumeFromApi = totalVolume;
            this.cryptoShare = cryptoShare;

        } else {
            volumeStore.getVolumes();
            [this.factoryVolume, this.factoryV2Volume, this.factoryCryptoVolume] = await Promise.all([
                volumeStore.factoryVolume(),
                volumeStore.factoryV2Volume(),
                volumeStore.factoryCryptoVolume(),
            ])
        }

        // Fetch deposit data
        const [
            { sumBalances },
            factoV2Pools,
            factoCryptoPools,
        ] = await Promise.all([
            getBalances(contract.default_account),
            getFactoryV2Pools(),
            getFactoryCryptoPools(),
        ]);

        const hasTvlDataAvailable = !!config.mainPoolsEndpoint;
        const { balances: balancesFacto, sumBalances: sumBalancesFacto } =
            await getFactoryOnlyPoolsBalances(contract.default_account, [...factoV2Pools, ...factoCryptoPools]);

        if (hasTvlDataAvailable) {
            this.total = sum(pools.map(({ usdTotalExcludingBasePool, usdTotal }) => usdTotalExcludingBasePool || usdTotal || 0));
        } else {
            const totalTvl = await balancesStore.totalBalances();
            this.total = Number(totalTvl) + sum(Array.from(Object.values(balancesFacto)) || 0);
        }

        this.sumBalances = Number(config.hasNoMainPools ? 0 : sumBalances) + Number(sumBalancesFacto);
    }

}
</script>

<style scoped>
    fieldset div {
        display: block;
    }
    fieldset div:nth-of-type(n+2), fieldset div:nth-of-type(3) {
        margin-top: 1em;
    }
    fieldset legend {
        text-align: center;
    }
</style>
